import { Component, Input, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AGMedia } from '@ag-common-lib/public-api';
import { FILE_NAME_VALIDATION_GROUP, MediaUploaderTabs, DEFAULT_MAX_MEDIA_UPLOAD_SIZE_MB } from '../ag-media-uploader-modal.models';
import { AgMediaUploaderModalService, FileData } from '../ag-media-uploader-modal.service';
import { UploadFromDiskTabComponent } from '../upload-from-disk-tab/upload-from-disk-tab.component';
import { UploadFromUrlTabComponent } from '../upload-from-url-tab/upload-from-url-tab.component';

@UntilDestroy()
@Component({
  selector: 'ag-shr-media-sources',
  templateUrl: './media-sources.component.html',
  styleUrls: ['./media-sources.component.scss'],
})
export class MediaSourcesComponent {
  @Input() accept = ['image/*'];
  @Input() set mediaPathPrefix(mediaPathPrefix: string) {
    this.mediaUploaderService.setPrefix(mediaPathPrefix);
  }
  @Input() set mediaSources(data: MediaUploaderTabs[]) {
    this.getMediaSources(data ?? this.defaultTabs);
  }
  @Input() placeholder: string;
  @Input() mediaItems: AGMedia[];
  @Input() useCustomMediaGallery: boolean = false;
  @Input() isSplitLayout: boolean = false;
  @Input() maxFileSizeMb = DEFAULT_MAX_MEDIA_UPLOAD_SIZE_MB;
  @Input() applyImageDownscale = false;

  @ViewChild(UploadFromDiskTabComponent, { static: false }) uploadFromDiskTabComponent: UploadFromDiskTabComponent;
  @ViewChild(UploadFromUrlTabComponent, { static: false }) uploadFromUrlTabComponent: UploadFromUrlTabComponent;

  protected tabConfig;
  protected MediaUploaderTabs = MediaUploaderTabs;
  protected FILE_NAME_VALIDATION_GROUP = FILE_NAME_VALIDATION_GROUP;
  protected selectedTabIndex$ = this.mediaUploaderService.selectedTabIndex$;
  protected selectedTab$ = this.mediaUploaderService.selectedTab$;
  protected inProgress$: Observable<boolean>;
  protected isFileSelected$: Observable<boolean>;
  protected fileData$: Observable<FileData>;

  private defaultTabs = [MediaUploaderTabs.FromFile, MediaUploaderTabs.ByURL, MediaUploaderTabs.Gallery];

  constructor(private mediaUploaderService: AgMediaUploaderModalService) {
    this.inProgress$ = this.mediaUploaderService.inProgress$;
    this.isFileSelected$ = this.mediaUploaderService.isFileSelected$;
    this.fileData$ = this.mediaUploaderService.file$;
  }

  protected onSelectedIndexChange = this.mediaUploaderService.onSelectedIndexChange;

  private getMediaSources(data: MediaUploaderTabs[]) {
    this.tabConfig = data.map(mediaSource => ({ id: mediaSource, text: mediaSource }));
    this.mediaUploaderService.setSelectedTab({ itemIndex: 0, itemData: this.tabConfig[0] });
  }
}
